import { useAuth } from "@/hooks/useAuth";
import PatientDashboard from "./PatientDashboard";
import DoctorDashboard from "./DoctorDashboard";

export default function Dashboard() {
  const { user } = useAuth();

  if (!user) {
    return <div>Loading...</div>;
  }

  // Route to appropriate dashboard based on user type
  if (user.userType === "patient") {
    return <PatientDashboard />;
  }

  // For doctors and practice owners, use the doctor dashboard
  return <DoctorDashboard />;
}